import { render, staticRenderFns } from "./SchoolFeeReport.vue?vue&type=template&id=a43a1a46&scoped=true"
import script from "./SchoolFeeReport.vue?vue&type=script&lang=js"
export * from "./SchoolFeeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43a1a46",
  null
  
)

export default component.exports